import React from 'react'
import { View, Text, TouchableOpacity, Image, StyleSheet } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'
import styles from './ModalDownloadCourseStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { StatusBar } from 'react-native'

const ModalDownloadCourse = ({ image, title, description, button, buttonDelete, buttonCancel, closeBottomSheet, courseDeleted }) => {
    const { languageFile } = getLanguage()

    const handleClosePress = () => {}

    return (
        <View>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}

            <View style={styles.container}>
                <Image style={image === require('../../../assets/circleLoader.gif') ? styles.circleLoader : styles.image} source={image} />
                <Text style={styles.title}>{title}</Text>

                <Text style={[styles.description, { marginBottom: 12 }]}>{description}</Text>
            </View>
            {!button && !buttonCancel && <View style={{ height: 24 }}></View>}
            {button && <View style={!buttonCancel ? styles.spacer : styles.spacerBis}></View>}
            {buttonDelete && <View style={!buttonCancel ? styles.spacer : styles.spacerBis}></View>}
            {button && (
                <View style={styles.buttonContainer}>
                    <TouchableOpacity onPress={() => (buttonCancel ? courseDeleted(true) : closeBottomSheet(true))} style={styles.mainButton}>
                        <Text style={styles.mainButtonText}>{languageFile.accept}</Text>
                    </TouchableOpacity>
                    {buttonCancel && (
                        <TouchableOpacity onPress={() => closeBottomSheet(true)} style={styles.borderButton}>
                            <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                        </TouchableOpacity>
                    )}
                </View>
            )}
            {buttonDelete && (
                <View style={styles.buttonContainer}>
                    <TouchableOpacity onPress={() => (buttonCancel ? courseDeleted(true) : closeBottomSheet(true))} style={styles.deleteButton}>
                        <Text style={styles.mainButtonText}>{languageFile.delete}</Text>
                    </TouchableOpacity>
                    {buttonCancel && (
                        <TouchableOpacity onPress={() => closeBottomSheet(true)} style={styles.borderButton}>
                            <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                        </TouchableOpacity>
                    )}
                </View>
            )}
        </View>
    )
}

export default ModalDownloadCourse
